import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import SideBar from "../views/SideBar";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Button } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import Swal from "sweetalert2";
import HeaderName from "./HeaderName";
import StockCountModal from "./StockCountModal";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from "react-router-dom";
import { PaginationControl } from "react-bootstrap-pagination-control";
import {
  FaTrashAlt,
  FaFileExport,
  FaAngleDoubleRight,
  FaCalculator,
  FaEye,
} from "react-icons/fa";
import Load from "../../../src/assets/img/load.gif";
import { useSelector } from "react-redux";
import ConvertDialog from "./Admin/Convert/stockConvertDialog";
function Stock() {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  // const url = 'http://localhost:9000/api/'
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const scroll = {
    height: "500px",

    overflowY: "scroll",
  };

  const batchScroll = {
    overflowX: "auto",
    // width: "1000px",
  };
  const Sort = (list) => {
    // console.log(arr,'what')
    setArr(list);
    list.sort(function (a, b) {
      if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
      if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
      return 0;
    });
  };
  let rowIndex = 1;
  const [arr, setArr] = useState([]);
  const [originalMedUnitLists, setOriginalMedUnitLists] = useState([]);
  const [accHOItemList, setAccHOItemList] = useState([]);
  const [medHOItemList, setMedHOItemList] = useState([]);
  const [proHOItemList, setProHOItemList] = useState([]);
  const [genHOItemList, setGenHOItemList] = useState([]);
  const [accHOCount, setAccHOCount] = useState("");
  const [medHOCount, setMedHOCount] = useState("");
  const [proHOCount, setProHOCount] = useState("");
  const [genHOCount, setGenHOCount] = useState("");
  const [medEvent, setMedEvent] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [searchProResults, setSearchProResults] = useState([]);
  const [showProSearch, setShowProSearch] = useState(false);
  const [hidePro, setHidePro] = useState(true);
  const [openConvert, setOpenConvert] = useState("");
  const [open, setOpen] = useState(false);

  const [branchID, setBranchID] = useState("");
  // console.log(branchID, "ID");
  const [searchMedResults, setSearchMedResults] = useState([]);
  const [showMedSearch, setShowMedSearch] = useState(false);
  const [hideMed, setHideMed] = useState(true);
  const [medName, setMedName] = useState("");

  const [searchProAccResults, setSearchProAccResults] = useState([]);
  const [showProAccSearch, setShowProAccSearch] = useState(false);
  const [hideProAcc, setHideProAcc] = useState(true);
  const [proAccName, setProAccName] = useState("");

  const [relatedBranch, setRelatedBranch] = useState([]);
  const [showBranch, setShowBranch] = useState(false);

  const [proUnitLists, setProUnitLists] = useState([]);
  const [medUnitLists, setMedUnitLists] = useState([]);
  const [proAssLists, setProAssLists] = useState([]);
  const [showMedicine, setShowMedicine] = useState(true);
  const [showProUnit, setShowProUnit] = useState(false);
  const [showProAss, setShowProAss] = useState(false);

  const [branchesLists, setBranchesLists] = useState([]);
  const [showItems, setShowItems] = useState(false);
  const [mQty, setMQty] = useState("");

  const [mTotal, setMTotal] = useState("");
  const [mbTotal, setMbTotal] = useState("");

  const [mSell, setMSell] = useState(0);
  const [mPurchase, setMPurchase] = useState(0);

  const [pmQty, setPMQty] = useState("");

  const [pmTotal, setPMTotal] = useState("");
  const [pmSell, setPMSell] = useState(0);
  const [pmPurchase, setPMPurchase] = useState(0);

  const [paQty, setPAQty] = useState("");

  const [paTotal, setPATotal] = useState("");
  const [paSell, setPASell] = useState(0);
  const [paPurchase, setPAPurchase] = useState(0);

  const [proId, setProId] = useState("");
  // const [proName, setProName] = useState('')

  //Med branch
  const paginationItems = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return medUnitLists.slice(start, end);
  }, [page, medUnitLists]);

  console.log(paginationItems, "paginationItems");
  const [medBranchLists, setMedBranchLists] = useState([]);
  const [showMedBranch, setShowMedBranch] = useState(false);

  //Pro Branch
  const [proBranchLists, setProBranchLists] = useState([]);
  const [showProBranch, setShowProBranch] = useState(false);

  //Pro Acc Branch
  const [proAccBranchLists, setProAccBranchLists] = useState([]);
  const [showProAccBranch, setShowProAccBranch] = useState(false);

  const [hO, setHO] = useState("");

  //Med Select
  const [medHOCheckList, setMedHOCheckList] = useState([]);

  //Pro Select
  const [proHOCheckList, setProHOCheckList] = useState([]);

  //Pro Ass Select
  const [proAssHOCheckList, setProAssHOCheckList] = useState([]);
  const [proTotal, setProTotal] = useState("");
  const [proAssTotal, setProAssTotal] = useState("");

  //General
  const [showGeneral, setShowGeneral] = useState(false);
  const [generalTable, setGeneralTable] = useState(false);
  const [generalBranch, setGeneralBranch] = useState(false);
  const [generalLists, setGeneralLists] = useState([]);
  const [generalTotal, setGeneralTotal] = useState("");
  const [searchGeneralResults, setSearchGeneralResults] = useState([]);
  const [showGeneralSearch, setShowGeneralSearch] = useState(false);
  const [generalHOCheckList, setGeneralHOCheckList] = useState([]);
  const [genSell, setGenSell] = useState("");
  const [genPurchase, setGenPurchase] = useState("");
  const [generalBranchLists, setGeneralBranchLists] = useState([]);
  const [itemsList, setItemsList] = useState([]);
  const [medTotal, setMedTotal] = useState("");
  const [medID, setMedID] = useState("");
  const [itemID, setItemID] = useState("");
  const [batchID, setBatchID] = useState("");

  const ButtonStyle = { margin: "10px 10px" };
  const ErrorColor = { border: "red" };
  const [expandedRows, setExpandedRows] = useState([]);

  const toggleRow = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };
  console.log(expandedRows, "exp");
  const handleMedCheck = (event, medUnit, type) => {
    if (event.target.checked) {
      setMedHOCheckList([
        ...medHOCheckList,
        medUnitLists.filter((data) => data._id === medUnit._id)[0],
      ]);
    } else {
      setMedHOCheckList((prevValue) =>
        prevValue.filter((data) => data._id !== medUnit._id)
      );
    }

    const NumberTable = ({ length }) => {
      const numbers = Array.from({ length }, (_, i) => i + 1);
      return numbers;
    };
    // console.log(
    //   [
    //     ...medHOCheckList,
    //     medHOItemList.filter(data => data._id === medUnit._id)[0]
    //   ],
    //   'id list'
    // )

    // setIsChecked(!isChecked)
  };
  const showDialog = (relatedMedicineID, itemID, bID) => {
    setOpenConvert(true);
    setMedID(relatedMedicineID);
    setItemID(itemID);
    setBatchID(bID);
  };
  const handleItems = (data) => {
    setShowItems(true);
    if (data[0]) {
      console.log(data[0], "dta");
      console.log(data[0]?.relatedSubItems, "it");
      setItemsList(data.relatedSubItems);
    }
  };
  const handleProCheck = (event, proUnit, type) => {
    if (event.target.checked) {
      setProHOCheckList([
        ...proHOCheckList,
        proUnitLists.filter((data) => data._id === proUnit._id)[0],
      ]);
    } else {
      setProHOCheckList((prevValue) =>
        prevValue.filter((data) => data._id !== proUnit._id)
      );
    }
  };
  const handleProSelectAll = (event, proUnit, type) => {
    if (event.target.checked) {
      setProHOCheckList(proUnit);
    }
  };
  const handleMedSelectAll = (event, medUnit, type) => {
    if (event.target.checked) {
      setMedHOCheckList(medUnit);
    }
  };
  const handleGenSelectAll = (event, genUnit, type) => {
    if (event.target.checked) {
      setGeneralHOCheckList(genUnit);
    }
  };

  const handleAccSelectAll = (event, accUnit, type) => {
    if (event.target.checked) {
      setProAssHOCheckList(accUnit);
    }
  };

  const handleProAssCheck = (event, proUnit, type) => {
    if (event.target.checked) {
      setProAssHOCheckList([
        ...proAssHOCheckList,
        proAssLists.filter((data) => data._id === proUnit._id)[0],
      ]);
    } else {
      setProAssHOCheckList((prevValue) =>
        prevValue.filter((data) => data._id !== proUnit._id)
      );
    }
  };

  const handleMUpdate = (medUnit) => {
    const data = {
      id: medUnit._id,
      currentQuantity: medUnit.currentQuantity,
      fromUnit: medUnit.fromUnit,
      toUnit: medUnit.toUnit,
      totalUnit: medUnit.currentQuantity * medUnit.toUnit,
    };

    if (mPurchase > 0) {
      data.purchasePrice = parseInt(mPurchase);
    }
    if (mSell > 0) {
      data.sellingPrice = parseInt(mSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("medicine-item", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  // const showID=(val)=>{
  //   console.log(val,'med id')
  // }
  const handlePAUpdate = (paUnit) => {
    //console.log(proId,'pro')
    const data = {
      id: paUnit._id,
      currentQuantity: paUnit.currentQuantity,
      fromUnit: paUnit.fromUnit,
      toUnit: paUnit.toUnit,
      totalUnit: paUnit.currentQuantity * paUnit.toUnit,
    };

    if (paPurchase > 0) {
      data.purchasePrice = parseInt(paPurchase);
    }
    if (paSell > 0) {
      data.sellingPrice = parseInt(paSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("accessory-item", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const handleGeneralUpdate = (genUnit) => {
    const data = {
      id: genUnit._id,
      currentQuantity: genUnit.currentQuantity,
      fromUnit: genUnit.fromUnit,
      toUnit: genUnit.toUnit,
      totalUnit: genUnit.currentQuantity * genUnit.toUnit,
    };

    if (genPurchase > 0) {
      data.purchasePrice = parseInt(genPurchase);
    }
    if (genSell > 0) {
      data.sellingPrice = parseInt(genSell);
    }

    // alert(JSON.stringify(data))

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("general-item", data, config)

      .then(function (response) {
        // console.log(response.data);
        Swal.fire({
          title: "Successful!",
          text: "Successfully Updated",
          icon: "success",

          cancelButtonText: "Close",
        });
        //         // window.location.reload()

        //         // setUnitLists([...unitLists,response.data.list])

        //         // setUnitLists(
        //         //   unitLists.map(category => {
        //         //     if (category._id === response.data.list._id) {
        //         //       return response.data.list
        //         //     } else {
        //         //       return category
        //         //     }
        //         //   })
        //         // )
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    // document.getElementById('desc').value = ''
    // document.getElementById('name').value = ''
    // document.getElementById('code').value = ''
  };

  const _export1 = React.useRef(null);
  const _export2 = React.useRef(null);
  const _export3 = React.useRef(null);
  const _export4 = React.useRef(null);

  const excelExport1 = () => {
    if (_export1.current !== null) {
      // console.log(_export1.current.props.data, 'excel')

      _export1.current.props.data.map(function (element, index) {
        element.code = element.code;
      });

      _export1.current.save();
    }
  };

  const excelExport2 = () => {
    if (_export2.current !== null) {
      // console.log(_export2.current.props.data, 'excel')

      _export2.current.props.data.map(function (element, index) {
        element.code = element.code;
      });

      _export2.current.save();
    }
  };

  const excelExport3 = () => {
    if (_export3.current !== null) {
      // console.log(_export3.current.props.data, 'excel')
      _export3.current.props.data.map(function (element, index) {
        element.code = element.code;
      });
      _export3.current.save();
    }
  };

  const excelExport4 = () => {
    if (_export4.current !== null) {
      _export4.current.props.data.map(function (element, index) {
        element.code = element.code;
      });
      _export4.current.save();
    }
  };

  useEffect(() => {
    const getProUnitLists = async () => {
      try {
        const res = await api.get("procedure-items?limit=30");

        setProUnitLists(
          res.data.list.sort(function (a, b) {
            if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
            if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
            return 0;
          })
        );
        // console.log(res.data.list, 'prounit l')
        // console.log(setProUnitLists.reOrderQuantity)
        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0
        );
        setProTotal(totalPrice);
        // console.log(totalPrice, 'total')

        setProId(res.data.list._id);
      } catch (err) {
        alert(err.message);
      }
    };

    const getMedUnitLists = async () => {
      try {
        const res = await api.get("medicine-items");
        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0
        );

        const total = res.data.list.reduce((totalAcc, medUnit) => {
          const subTotal = medUnit.relatedSubItems.reduce((itemAcc, item) => {
            const itemSum = item.batches
              .filter((el) => !el.relatedBranch?._id)
              .reduce(
                (batchAcc, cur) => batchAcc + parseInt(cur.purchasePrice || 0),
                0
              );

            return itemAcc + itemSum;
          }, 0);

          return totalAcc + subTotal;
        }, 0);
        const branchTotal = res.data.list.reduce((totalAcc, medUnit) => {
          const subTotal = medUnit.relatedSubItems.reduce((itemAcc, item) => {
            const itemSum = item.batches
              .filter((el) => el.relatedBranch?._id === branchID)
              .reduce(
                (batchAcc, cur) => batchAcc + parseInt(cur.purchasePrice || 0),
                0
              );

            return itemAcc + itemSum;
          }, 0);

          return totalAcc + subTotal;
        }, 0);
        console.log(total, "meddddd");
        setMedTotal(branchID ? branchTotal : total);
        Sort(res.data.list);
        setMedUnitLists(res.data.list);
        setOriginalMedUnitLists(res.data.list);
        // console.log(arr,'meddddd')
        //         console.log(res.data.list.sort(function(a, b) {
        //   if(a.code.toLowerCase() < b.code.toLowerCase()) return -1;
        //   if(a.code.toLowerCase() > b.code.toLowerCase()) return 1;
        //   return 0;
        //  }), 'ori me list')
      } catch (err) {
        alert(err.message);
      }
    };

    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchesLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };

    const getProAssLists = async () => {
      try {
        const res = await api.get("accessory-items?limit=30");
        setProAssLists(
          res.data.list.sort(function (a, b) {
            if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
            if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
            return 0;
          })
        );
        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0
        );
        setProAssTotal(totalPrice);

        // console.log(res.data.list, 'pro ass')
      } catch (err) {
        alert(err.message);
      }
    };

    const getGeneralLists = async () => {
      try {
        const res = await api.get("general-items");
        setGeneralLists(
          res.data.list.sort(function (a, b) {
            if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
            if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
            return 0;
          })
        );
        // console.log(res.data.list)

        const totalPrice = res.data.list.reduce(
          (accumulator, currentValue) =>
            accumulator +
            currentValue.purchasePrice * currentValue.currentQuantity,
          0
        );
        // console.log(totalPrice, 'gen li')
        setGeneralTotal(totalPrice);
      } catch (err) {
        alert(err.message);
      }
    };

    const getPurchaseLists = async () => {
      try {
        const res = await api.get(
          "purchase-requests"
          //'http://localhost:9000/api/treatments'
        );

        setMedHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.medicineItems[0])
            .filter(
              (i) =>
                i.medicineItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                )[0]
            )
        );
        setProHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.procedureItems[0])
            .filter(
              (i) =>
                i.procedureItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                )[0]
            )
        );
        setAccHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.accessoryItems[0])
            .filter(
              (i) =>
                i.accessoryItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                )[0]
            )
        );
        setGenHOItemList(
          res.data.list
            .filter((el) => el.relatedApprove && el.generalItems[0])
            .filter(
              (i) =>
                i.generalItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                )[0]
            )
        );
        setMedHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.medicineItems[0])
            .filter(
              (i) =>
                i.medicineItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                )[0]
            ).length
        );
        setProHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.procedureItems[0])
            .filter(
              (i) =>
                i.procedureItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                )[0]
            ).length
        );
        setAccHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.accessoryItems[0])
            .filter(
              (i) =>
                i.accessoryItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                )[0]
            ).length
        );
        setGenHOCount(
          res.data.list
            .filter((el) => el.relatedApprove && el.generalItems[0])
            .filter(
              (i) =>
                i.generalItems.filter(
                  (e) =>
                    new Date(e.alertDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    }) ===
                    new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                )[0]
            ).length
        );
      } catch (err) {
        alert(err.message);
      }
    };
    getPurchaseLists();
    getGeneralLists();
    getProAssLists();
    getBranches();

    getMedUnitLists();
    getProUnitLists();
  }, [branchID]);
  const medSearch = (medName) => {
    setMedEvent(medName);

    if (medName) {
      const filtered = originalMedUnitLists.filter(
        (el) =>
          (el?.medicineItemName || "")
            .toLowerCase()
            .includes(medName.toLowerCase()) ||
          (el?.name?.relatedBrand?.name || "")
            .toLowerCase()
            .includes(medName.toLowerCase()) ||
          (el?.code || "").toLowerCase().includes(medName.toLowerCase())
      );
      setMedUnitLists(filtered);

      setShowMedSearch(true);
      setHideMed(false);
    } else {
      setMedUnitLists(originalMedUnitLists);
      setShowMedSearch(false);
      setHideMed(true);
    }
  };

  //For Hide and Show related branch data
  const handleBranch = (event) => {
    if (event === "HO") {
      setHO(event);
      window.location.reload();
      // console.log()
    } else {
      setBranchID(event);
      setShowMedBranch(true);
      setHideMed(false);
      setShowMedSearch(false);
    }
  };
  console.log(medBranchLists, "mmm");
  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <HeaderName />
        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active '>
                      Stock Count & Price
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='row d-flex justify-content-between'>
                <div className='col-md-6'>
                  {/* <h4>Medicine Item List</h4> */}
                </div>
                <div className='offset-1 col-md-4 ml-5'>
                  <div
                    className='input-group row ml-5'
                    style={{ marginBottom: "20px" }}
                  >
                    {/* <div className="col-md-6 mt-1">
                      <button
                        type="button"
                        className="btn  btn-primary ml-4"
                        style={{ borderRadius: "7px" }}
                        onClick={showDialog}>
                        Add Item
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='card'>
                    <div className='card-header'>
                      <div className='row'>
                        <div className='col-md-8'>
                          <div className='row'>
                            <div className='col-2'>
                              <button
                                type='button'
                                className='btn btn-sm btn-dark'
                                onClick={excelExport2}
                              >
                                <FaFileExport />
                                &nbsp; Export
                              </button>
                              &nbsp;
                              {/* <button
                                          type='button'
                                          className='btn btn-sm btn-dark'
                                          onClick={() => setOpen(true)}
                                        >
                                          Data Entry
                                        </button> */}
                            </div>
                            <div className='col-md-5 mt-1'>
                              <b className='btn btn-sm btn-dark'>
                                Total Inventory Value :{" "}
                                {medTotal ? medTotal.toFixed(2) : ""} MMK
                              </b>
                            </div>
                          </div>
                        </div>
                        <div className='offset-1 col-md-3 mt-1'>
                          <div className='form-group'>
                            <select
                              name='currency'
                              id=''
                              className='form-control mt-1'
                              onchange='convert(this.value)'
                              // placeholder='Filter By Branches'
                              onChange={(e) => {
                                handleBranch(e.target.value);
                                setHO(e.target.value);
                              }}
                            >
                              <option hidden>Filter By Branches</option>
                              <option value='HO'>HO</option>

                              {branchesLists.map((option) => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='card-body'>
                      {/* Export data in Excel */}

                      {/* For Medicine Items */}
                      <ExcelExport data={medHOCheckList} ref={_export2}>
                        <ExcelExportColumn
                          field=''
                          title='No'
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field='code'
                          title='Code'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />
                        <ExcelExportColumn
                          field='name.relatedBrand.name'
                          title='Brand'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field='medicineItemName'
                          title='Medicine Item Name'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field='currentQuantity'
                          title='Qty'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field='fromUnit'
                          title='From Unit'
                          width={150}
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                        />
                        <ExcelExportColumn
                          field='toUnit'
                          title='To Unit'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field='totalUnit'
                          title='Total Unit'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field='sellingPrice'
                          title='Selling Price'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field='purchasePrice'
                          title='Purchase Price'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field='unit'
                          title='Unit'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field='description'
                          title='Desc'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field='actualStock'
                          title='Actual Stock'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />

                        <ExcelExportColumn
                          field='different'
                          title='Different'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field='checkby'
                          title='Checked By'
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                      </ExcelExport>
                      {/* End     */}

                      {/* End */}

                      {/* Export Data in Excel end */}

                      {showMedicine && (
                        <div>
                          {showMedBranch ? (
                            ""
                          ) : (
                            <>
                              <div className='row mb-3'>
                                <div className='col-2'>
                                  <input
                                    type='search'
                                    className='form-control rounded '
                                    style={{ borderRadius: "17px" }}
                                    onChange={(e) => medSearch(e.target.value)}
                                    id='search_code'
                                    placeholder='Search Items'
                                  />
                                </div>
                              </div>
                            </>
                          )}
                          <div>
                            {medUnitLists[0] ? (
                              <>
                                <div className='row'>
                                  <div className='col-12'>
                                    <div className='table' style={scroll}>
                                      <table className='table table-hover'>
                                        <thead
                                          className='sticky-top bg-light'
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            // width: "900px",
                                          }}
                                        >
                                          <tr>
                                            <th style={{ fontWeight: "400px" }}>
                                              #
                                            </th>
                                            <th style={{ fontWeight: "400px" }}>
                                              Code
                                            </th>
                                            <th>Brand</th>
                                            <th style={{ fontWeight: "400px" }}>
                                              Name
                                            </th>

                                            <th style={{ fontWeight: "400px" }}>
                                              Total Unit
                                            </th>

                                            <th>Desc</th>

                                            <th
                                              className='text-center'
                                              style={{ fontWeight: "400px" }}
                                            >
                                              Action
                                            </th>
                                            {(hideMed || showMedSearch) && (
                                              <th className='text-center'>
                                                Select All &nbsp;
                                                <input
                                                  type='checkbox'
                                                  onClick={(e) =>
                                                    handleMedSelectAll(
                                                      e,
                                                      medUnitLists,
                                                      "checkBox"
                                                    )
                                                  }
                                                />
                                              </th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody id=''>
                                          {showMedSearch &&
                                            paginationItems.map(
                                              (medUnit, i) => (
                                                <React.Fragment key={i}>
                                                  <tr>
                                                    <td>{++i}</td>
                                                    <td>{medUnit.code}</td>
                                                    <td>
                                                      {medUnit.name
                                                        ? medUnit.name
                                                            .relatedBrand.name
                                                        : ""}
                                                    </td>
                                                    <td>
                                                      {medUnit.medicineItemName}
                                                    </td>
                                                    <td>
                                                      {medUnit.totalUnit || 0}
                                                    </td>
                                                    <td>
                                                      {medUnit.description}
                                                    </td>

                                                    <td className='flex w-responsive text-center'>
                                                      <span
                                                        // onClick={() =>
                                                        //   handleItems(medUnit)
                                                        // }
                                                        onClick={() =>
                                                          toggleRow(medUnit._id)
                                                        }
                                                        className=' btn btn-sm btn-dark mt-3'
                                                      >
                                                        <FaEye />
                                                      </span>
                                                      {/* <span
                                                    onClick={()=>showDialog(medUnit._id,)
                                                      
                                                    }
                                                    className=' btn btn-sm btn-dark mt-3'
                                                  >
                                                    <FaAngleDoubleRight />
                                                  </span> */}
                                                    </td>
                                                    <td className='text-center'>
                                                      <input
                                                        type='checkbox'
                                                        key={medUnit}
                                                        // value={isChecked}
                                                        //   checked={medUnit.find(
                                                        //     item =>
                                                        //       item._id === medUnit._id
                                                        //   )}
                                                        // />
                                                        onClick={(e) =>
                                                          handleMedCheck(
                                                            e,
                                                            medUnit,
                                                            "checkBox"
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                  </tr>
                                                  {expandedRows.includes(
                                                    medUnit._id
                                                  ) && (
                                                    <tr>
                                                      <td colSpan={8}>
                                                        <div
                                                          style={{
                                                            overflowX: "auto",
                                                            // width: "100%",
                                                          }}
                                                        >
                                                          <table
                                                            border='1'
                                                            cellPadding='6'
                                                            className='table-auto' // Tailwind min-width (optional)
                                                          >
                                                            <thead>
                                                              <tr>
                                                                <th className='text-center'>
                                                                  No.
                                                                </th>
                                                                <th className='text-center'>
                                                                  Type
                                                                </th>
                                                                <th className='text-center'>
                                                                  Purchase Date
                                                                </th>
                                                                <th className='text-center'>
                                                                  Item Name
                                                                </th>
                                                                <th className='text-center'>
                                                                  Quantity
                                                                </th>
                                                                {/* <th>From Unit</th> */}
                                                                {/* <th>To Unit</th> */}
                                                                <th className='text-center'>
                                                                  Total Qty
                                                                </th>
                                                                {/* <th>
                                                                From Unit Name
                                                              </th> */}
                                                                <th>
                                                                  Unit Name
                                                                </th>
                                                                <th className='text-center'>
                                                                  Purchase Price
                                                                </th>
                                                                <th className='text-center'>
                                                                  Selling Price
                                                                </th>
                                                                <th>
                                                                  Expired Date
                                                                </th>
                                                                <th className='text-center'>
                                                                  Action
                                                                </th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {medUnit.relatedSubItems.map(
                                                                (item, idx) =>
                                                                  item.batches
                                                                    .filter(
                                                                      (el) =>
                                                                        !el.relatedBranch
                                                                    )
                                                                    ?.map(
                                                                      (
                                                                        b,
                                                                        bi
                                                                      ) => (
                                                                        <tr
                                                                          key={
                                                                            idx
                                                                          }
                                                                        >
                                                                          <td>
                                                                            {
                                                                              rowIndex++
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              b?.type
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {b?.relatedPurchaseRequest?.purchaseDate?.split(
                                                                              "T"
                                                                            )[0] ||
                                                                              "not set"}
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              item
                                                                                ?.relatedItem
                                                                                ?.medicineItemName
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              b?.currentQuantity
                                                                            }
                                                                          </td>
                                                                          {/* <td>
                                                                          {
                                                                            item?.fromUnit
                                                                          }
                                                                        </td> */}
                                                                          {/* <td>
                                                                          {
                                                                            item?.toUnit
                                                                          }
                                                                        </td> */}
                                                                          <td>
                                                                            {
                                                                              b.totalUnit
                                                                            }
                                                                          </td>
                                                                          {/* <td>
                                                                          {
                                                                            item
                                                                              ?.relatedFromUnit
                                                                              ?.unitName
                                                                          }
                                                                        </td> */}
                                                                          <td>
                                                                            {item
                                                                              ?.relatedItemUnit
                                                                              ?.unitName ||
                                                                              item
                                                                                ?.relatedToUnit
                                                                                ?.unitName}
                                                                          </td>
                                                                          <td className='text-center'>
                                                                            <input
                                                                              type='number'
                                                                              defaultValue={
                                                                                b?.purchasePrice
                                                                              }
                                                                              onChange={(
                                                                                e
                                                                              ) =>
                                                                                setMPurchase(
                                                                                  e
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                              className='p-2 w-75 rounded-lg'
                                                                            />
                                                                          </td>
                                                                          <td className='text-center'>
                                                                            <input
                                                                              type='number'
                                                                              defaultValue={
                                                                                b?.sellingPrice
                                                                              }
                                                                              onChange={(
                                                                                e
                                                                              ) =>
                                                                                setMSell(
                                                                                  e
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                              className='p-2 w-75 rounded-lg'
                                                                            />
                                                                          </td>

                                                                          <td>
                                                                            {
                                                                              b?.expiredDate?.split(
                                                                                "T"
                                                                              )[0]
                                                                            }
                                                                          </td>
                                                                          <td className='flex'>
                                                                            <span
                                                                              onClick={() =>
                                                                                showDialog(
                                                                                  medUnit,
                                                                                  item,
                                                                                  b
                                                                                )
                                                                              }
                                                                              className=' btn btn-sm btn-dark mt-3'
                                                                            >
                                                                              {/* <FaAngleDoubleRight /> */}
                                                                              Update
                                                                            </span>
                                                                            &nbsp;
                                                                            <span
                                                                              onClick={() =>
                                                                                showDialog(
                                                                                  medUnit,
                                                                                  item,
                                                                                  b
                                                                                )
                                                                              }
                                                                              className=' btn btn-sm btn-dark mt-3'
                                                                            >
                                                                              {/* <FaAngleDoubleRight /> */}
                                                                              Convert
                                                                            </span>
                                                                          </td>
                                                                        </tr>
                                                                      )
                                                                    )
                                                              )}
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </React.Fragment>
                                              )
                                            )}

                                          {hideMed &&
                                            paginationItems.map(
                                              (medUnit, i) => (
                                                <React.Fragment key={i}>
                                                  <tr>
                                                    <td>
                                                      {(page - 1) * 20 + i + 1}
                                                    </td>
                                                    <td>{medUnit.code}</td>
                                                    <td>
                                                      {medUnit.name
                                                        ? medUnit.name
                                                            .relatedBrand.name
                                                        : ""}
                                                    </td>
                                                    <td>
                                                      {medUnit.medicineItemName}
                                                    </td>
                                                    <td>
                                                      {medUnit.totalUnit || 0}
                                                    </td>
                                                    <td>
                                                      {medUnit.description}
                                                    </td>

                                                    <td className='flex w-responsive text-center'>
                                                      <span
                                                        // onClick={() =>
                                                        //   handleItems(medUnit)
                                                        // }
                                                        onClick={() =>
                                                          toggleRow(medUnit._id)
                                                        }
                                                        className=' btn btn-sm btn-dark mt-3'
                                                      >
                                                        <FaEye />
                                                      </span>
                                                      {/* <span
                                                    onClick={()=>showDialog(medUnit._id,)
                                                      
                                                    }
                                                    className=' btn btn-sm btn-dark mt-3'
                                                  >
                                                    <FaAngleDoubleRight />
                                                  </span> */}
                                                    </td>
                                                    <td className='text-center'>
                                                      <input
                                                        type='checkbox'
                                                        key={medUnit}
                                                        // value={isChecked}
                                                        //   checked={medUnit.find(
                                                        //     item =>
                                                        //       item._id === medUnit._id
                                                        //   )}
                                                        // />
                                                        onClick={(e) =>
                                                          handleMedCheck(
                                                            e,
                                                            medUnit,
                                                            "checkBox"
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                  </tr>
                                                  {expandedRows.includes(
                                                    medUnit._id
                                                  ) && (
                                                    <tr>
                                                      <td colSpan={8}>
                                                        <div
                                                          style={{
                                                            overflowX: "auto",
                                                            // width: "100%",
                                                          }}
                                                        >
                                                          <table
                                                            border='1'
                                                            cellPadding='6'
                                                            className='table-auto' // Tailwind min-width (optional)
                                                          >
                                                            <thead>
                                                              <tr>
                                                                <th className='text-center'>
                                                                  No.
                                                                </th>
                                                                <th className='text-center'>
                                                                  Type
                                                                </th>
                                                                <th className='text-center'>
                                                                  Purchase Date
                                                                </th>
                                                                <th className='text-center'>
                                                                  Item Name
                                                                </th>
                                                                <th className='text-center'>
                                                                  Quantity
                                                                </th>
                                                                {/* <th>From Unit</th> */}
                                                                {/* <th>To Unit</th> */}
                                                                <th className='text-center'>
                                                                  Total Qty
                                                                </th>
                                                                {/* <th>
                                                                From Unit Name
                                                              </th> */}
                                                                <th>
                                                                  Unit Name
                                                                </th>
                                                                <th className='text-center'>
                                                                  Purchase Price
                                                                </th>
                                                                <th className='text-center'>
                                                                  Selling Price
                                                                </th>
                                                                <th>
                                                                  Expired Date
                                                                </th>
                                                                <th className='text-center'>
                                                                  Action
                                                                </th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {medUnit.relatedSubItems.map(
                                                                (item, idx) =>
                                                                  item.batches
                                                                    .filter(
                                                                      (el) =>
                                                                        !el.relatedBranch
                                                                    )
                                                                    ?.map(
                                                                      (
                                                                        b,
                                                                        bi
                                                                      ) => (
                                                                        <tr
                                                                          key={
                                                                            idx
                                                                          }
                                                                        >
                                                                          <td>
                                                                            {
                                                                              rowIndex++
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              b?.type
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {b?.relatedPurchaseRequest?.purchaseDate?.split(
                                                                              "T"
                                                                            )[0] ||
                                                                              "not set"}
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              item
                                                                                ?.relatedItem
                                                                                ?.medicineItemName
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              b?.currentQuantity
                                                                            }
                                                                          </td>
                                                                          {/* <td>
                                                                          {
                                                                            item?.fromUnit
                                                                          }
                                                                        </td> */}
                                                                          {/* <td>
                                                                          {
                                                                            item?.toUnit
                                                                          }
                                                                        </td> */}
                                                                          <td>
                                                                            {
                                                                              b.totalUnit
                                                                            }
                                                                          </td>
                                                                          {/* <td>
                                                                          {
                                                                            item
                                                                              ?.relatedFromUnit
                                                                              ?.unitName
                                                                          }
                                                                        </td> */}
                                                                          <td>
                                                                            {item
                                                                              ?.relatedItemUnit
                                                                              ?.unitName ||
                                                                              item
                                                                                ?.relatedToUnit
                                                                                ?.unitName}
                                                                          </td>
                                                                          <td className='text-center'>
                                                                            <input
                                                                              type='number'
                                                                              defaultValue={
                                                                                b?.purchasePrice
                                                                              }
                                                                              onChange={(
                                                                                e
                                                                              ) =>
                                                                                setMPurchase(
                                                                                  e
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                              className='p-2 w-75 rounded-lg'
                                                                            />
                                                                          </td>
                                                                          <td className='text-center'>
                                                                            <input
                                                                              type='number'
                                                                              defaultValue={
                                                                                b?.sellingPrice
                                                                              }
                                                                              onChange={(
                                                                                e
                                                                              ) =>
                                                                                setMSell(
                                                                                  e
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                              className='p-2 w-75 rounded-lg'
                                                                            />
                                                                          </td>

                                                                          <td>
                                                                            {
                                                                              b?.expiredDate?.split(
                                                                                "T"
                                                                              )[0]
                                                                            }
                                                                          </td>
                                                                          <td className='flex'>
                                                                            <span
                                                                              onClick={() =>
                                                                                showDialog(
                                                                                  medUnit,
                                                                                  item,
                                                                                  b
                                                                                )
                                                                              }
                                                                              className=' btn btn-sm btn-dark mt-3'
                                                                            >
                                                                              {/* <FaAngleDoubleRight /> */}
                                                                              Update
                                                                            </span>
                                                                            &nbsp;
                                                                            <span
                                                                              onClick={() =>
                                                                                showDialog(
                                                                                  medUnit,
                                                                                  item,
                                                                                  b
                                                                                )
                                                                              }
                                                                              className=' btn btn-sm btn-dark mt-3'
                                                                            >
                                                                              {/* <FaAngleDoubleRight /> */}
                                                                              Convert
                                                                            </span>
                                                                          </td>
                                                                        </tr>
                                                                      )
                                                                    )
                                                              )}
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </React.Fragment>
                                              )
                                            )}

                                          {showMedBranch &&
                                            paginationItems.map(
                                              (medUnit, i) => (
                                                <React.Fragment key={i}>
                                                  <tr>
                                                    <td>
                                                      {(page - 1) * 20 + i + 1}
                                                    </td>
                                                    <td>{medUnit.code}</td>
                                                    <td>
                                                      {medUnit.name
                                                        ? medUnit.name
                                                            .relatedBrand.name
                                                        : ""}
                                                    </td>
                                                    <td>
                                                      {medUnit.medicineItemName}
                                                    </td>
                                                    <td>
                                                      {medUnit.relatedSubItems.reduce(
                                                        (total, item) => {
                                                          const itemSum =
                                                            item.batches
                                                              .filter(
                                                                (el) =>
                                                                  el
                                                                    .relatedBranch
                                                                    ?._id ===
                                                                  branchID
                                                              )
                                                              .reduce(
                                                                (acc, cur) =>
                                                                  acc +
                                                                  parseInt(
                                                                    cur.currentQuantity
                                                                  ),
                                                                0
                                                              );
                                                          return (
                                                            total + itemSum
                                                          );
                                                        },
                                                        0
                                                      )}
                                                    </td>
                                                    <td>
                                                      {medUnit.description}
                                                    </td>

                                                    <td className='flex w-responsive text-center'>
                                                      <span
                                                        // onClick={() =>
                                                        //   handleItems(medUnit)
                                                        // }
                                                        onClick={() =>
                                                          toggleRow(medUnit._id)
                                                        }
                                                        className=' btn btn-sm btn-dark mt-3'
                                                      >
                                                        <FaEye />
                                                      </span>
                                                      {/* <span
                                                    onClick={()=>showDialog(medUnit._id,)
                                                      
                                                    }
                                                    className=' btn btn-sm btn-dark mt-3'
                                                  >
                                                    <FaAngleDoubleRight />
                                                  </span> */}
                                                    </td>
                                                    <td className='text-center'>
                                                      <input
                                                        type='checkbox'
                                                        key={medUnit}
                                                        // value={isChecked}
                                                        //   checked={medUnit.find(
                                                        //     item =>
                                                        //       item._id === medUnit._id
                                                        //   )}
                                                        // />
                                                        onClick={(e) =>
                                                          handleMedCheck(
                                                            e,
                                                            medUnit,
                                                            "checkBox"
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                  </tr>
                                                  {expandedRows.includes(
                                                    medUnit._id
                                                  ) && (
                                                    <tr>
                                                      <td colSpan={18}>
                                                        <div
                                                          style={{
                                                            overflowX: "auto",
                                                            // width: "100%",
                                                          }}
                                                        >
                                                          <table
                                                            border='1'
                                                            cellPadding='6'
                                                            className='table-auto' // Tailwind min-width (optional)
                                                          >
                                                            <thead>
                                                              <tr>
                                                                <th className='text-center'>
                                                                  No.
                                                                </th>
                                                                <th className='text-center'>
                                                                  Type
                                                                </th>
                                                                <th className='text-center'>
                                                                  Purchase Date
                                                                </th>
                                                                <th className='text-center'>
                                                                  Branch Name
                                                                </th>
                                                                <th className='text-center'>
                                                                  Item Name
                                                                </th>
                                                                <th className='text-center'>
                                                                  Quantity
                                                                </th>
                                                                {/* <th>From Unit</th> */}
                                                                {/* <th>To Unit</th> */}
                                                                <th className='text-center'>
                                                                  Total Qty
                                                                </th>
                                                                {/* <th>
                                                                From Unit Name
                                                              </th> */}
                                                                <th>
                                                                  Unit Name
                                                                </th>
                                                                <th className='text-center'>
                                                                  Purchase Price
                                                                </th>
                                                                <th className='text-center'>
                                                                  Selling Price
                                                                </th>
                                                                <th>
                                                                  Expired Date
                                                                </th>
                                                                <th className='text-center'>
                                                                  Action
                                                                </th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {medUnit.relatedSubItems.map(
                                                                (item, idx) =>
                                                                  item.batches
                                                                    .filter(
                                                                      (el) =>
                                                                        el
                                                                          .relatedBranch
                                                                          ?._id ===
                                                                        branchID
                                                                    )
                                                                    ?.map(
                                                                      (
                                                                        b,
                                                                        bi
                                                                      ) => (
                                                                        <tr
                                                                          key={
                                                                            idx
                                                                          }
                                                                        >
                                                                          <td>
                                                                            {
                                                                              rowIndex++
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              b?.type
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {b?.relatedPurchaseRequest?.purchaseDate?.split(
                                                                              "T"
                                                                            )[0] ||
                                                                              "not set"}
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              b
                                                                                ?.relatedBranch
                                                                                ?.name
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              item
                                                                                ?.relatedItem
                                                                                ?.medicineItemName
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              b?.currentQuantity
                                                                            }
                                                                          </td>
                                                                          {/* <td>
                                                                          {
                                                                            item?.fromUnit
                                                                          }
                                                                        </td> */}
                                                                          {/* <td>
                                                                          {
                                                                            item?.toUnit
                                                                          }
                                                                        </td> */}
                                                                          <td>
                                                                            {
                                                                              b.totalUnit
                                                                            }
                                                                          </td>
                                                                          {/* <td>
                                                                          {
                                                                            item
                                                                              ?.relatedFromUnit
                                                                              ?.unitName
                                                                          }
                                                                        </td> */}
                                                                          <td>
                                                                            {item
                                                                              ?.relatedItemUnit
                                                                              ?.unitName ||
                                                                              item
                                                                                ?.relatedToUnit
                                                                                ?.unitName}
                                                                          </td>
                                                                          <td className='text-center'>
                                                                            <input
                                                                              type='number'
                                                                              defaultValue={
                                                                                b?.purchasePrice
                                                                              }
                                                                              onChange={(
                                                                                e
                                                                              ) =>
                                                                                setMPurchase(
                                                                                  e
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                              className='p-2 w-75 rounded-lg '
                                                                            />
                                                                          </td>
                                                                          <td className='text-center'>
                                                                            <input
                                                                              type='number'
                                                                              defaultValue={
                                                                                b?.sellingPrice
                                                                              }
                                                                              onChange={(
                                                                                e
                                                                              ) =>
                                                                                setMSell(
                                                                                  e
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                              className='p-2 w-75 rounded-lg'
                                                                            />
                                                                          </td>

                                                                          <td className='text-center font-weight-bold'>
                                                                            {
                                                                              b?.expiredDate?.split(
                                                                                "T"
                                                                              )[0]
                                                                            }
                                                                          </td>
                                                                          <td className='flex gap-2 justify-content-between'>
                                                                            <span
                                                                              onClick={() =>
                                                                                showDialog(
                                                                                  medUnit,
                                                                                  item,
                                                                                  b
                                                                                )
                                                                              }
                                                                              className=' btn btn-sm btn-dark mt-3'
                                                                            >
                                                                              {/* <FaAngleDoubleRight /> */}
                                                                              Update
                                                                            </span>
                                                                            &nbsp;
                                                                            <span
                                                                              onClick={() =>
                                                                                showDialog(
                                                                                  medUnit,
                                                                                  item,
                                                                                  b
                                                                                )
                                                                              }
                                                                              className=' btn btn-sm btn-dark mt-3'
                                                                            >
                                                                              {/* <FaAngleDoubleRight /> */}
                                                                              Convert
                                                                            </span>
                                                                          </td>
                                                                        </tr>
                                                                      )
                                                                    )
                                                              )}
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </React.Fragment>
                                              )
                                            )}
                                        </tbody>
                                      </table>
                                    </div>
                                    <div className='mt-4'>
                                      <PaginationControl
                                        page={page}
                                        between={4}
                                        total={medUnitLists?.length}
                                        limit={20}
                                        changePage={(page) => {
                                          setPage(page);
                                        }}
                                        ellipsis={1}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className='row'>
                                <div className='offset-3 col-4'>
                                  <img
                                    src={Load}
                                    alt='i'
                                    width='200px'
                                    height='100px'
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <StockCountModal
                open={open}
                close={() => setOpen(false)}
                branchesLists={branchesLists}
                setOpen={setOpen}
              />
              <ConvertDialog
                open={openConvert}
                close={() => setOpenConvert(false)}
                branchesLists={branchesLists}
                setOpenConvert={setOpenConvert}
                medID={medID}
                itemID={itemID}
                batchID={batchID}
                branchID={branchID}
              />
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer' style={{ marginTop: "1rem" }}>
        <strong>
          Copyright &copy; 2017-2020
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default Stock;
